<ng-container
  *ngTemplateOutlet="
    contentTpl;
    context: {
      title: activeStreamItem?.stream?.title || data.title,
      subtitle: activeStreamItem?.stream?.subtitle || data.subtitle,
      titleHash: activeStreamItem?.stream?.titleHash || data.titleHash,
      fuelLabel: (activeStreamItem?.stream && activeStreamItem?.stream?.fuelLabel) || data.fuelLabel,
      media: activeStreamItem?.stream?.background || data.background,
      links: activeStreamItem?.links || data.links,
      hideAnnouncements: !!activeStreamItem,
    }
  "
></ng-container>
<ng-template
  #contentTpl
  let-title="title"
  let-subtitle="subtitle"
  let-titleHash="titleHash"
  let-fuelLabel="fuelLabel"
  let-media="media"
  let-links="links"
  let-hideAnnouncements="hideAnnouncements"
>
  @if (data.layout === teaserLayout.NORMAL) {
    <mb-announcement-banner-large
      [title]="title"
      [subtitle]="subtitle"
      [titleHash]="titleHash"
      [fuelLabel]="fuelLabel"
      [links]="links"
      [teasers]="data.teasers"
      [media]="media"
      [hideAnnouncements]="hideAnnouncements"
    ></mb-announcement-banner-large>
  }
  @if (data.layout === teaserLayout.NORMAL_COUNTDOWN_BELOW) {
    <mb-announcement-banner-large
      [title]="title"
      [subtitle]="subtitle"
      [titleHash]="titleHash"
      [fuelLabel]="fuelLabel"
      [links]="links"
      [teasers]="data.teasers"
      [media]="media"
      [hideAnnouncements]="hideAnnouncements"
      [isBelowCountdown]="true"
    ></mb-announcement-banner-large>
  }

  <!-- Small banner layout only shows the first teaser -->
  @if (data.singleAnnouncement && data.layout === teaserLayout.SMALL) {
    <mb-announcement-banner-small
      [title]="data.title"
      [subtitle]="data.subtitle"
      [titleHash]="data.titleHash"
      [withCountdown]="true"
      [countdownType]="data.singleAnnouncement.showDaysOnly ? countdownTypes.DAYS : countdownTypes.FULL"
      [countdownLabel]="data.singleAnnouncement.countdownLabel || ''"
      [countdownDate]="data.singleAnnouncement.countdownDate || null"
      [fuelLabel]="data.fuelLabel"
      [media]="data.background"
      [routerLink]="data.links.length ? data.links[0].link : ''"
      [class.has-link]="!!data.links.length"
    ></mb-announcement-banner-small>
  }
  @if (data.layout === teaserLayout.SMALL_WITHOUT_COUNTDOWN) {
    <mb-announcement-banner-small
      [title]="data.title"
      [subtitle]="data.subtitle"
      [titleHash]="data.titleHash"
      [withCountdown]="false"
      [countdownLabel]="data.teasers.length ? data.teasers[0].countdownLabel : ''"
      [countdownDate]="data.teasers.length ? data.teasers[0].countdownDate : null"
      [fuelLabel]="data.fuelLabel"
      [media]="data.background"
      [routerLink]="data.links.length ? data.links[0].link : ''"
      [class.has-link]="!!data.links.length"
    ></mb-announcement-banner-small>
  }
  @if (data.singleAnnouncement && data.layout === teaserLayout.SMALL_COUNTDOWN_REAR) {
    <mb-announcement-banner-small
      [title]="data.title"
      [subtitle]="data.subtitle"
      [titleHash]="data.titleHash"
      [withCountdown]="true"
      [countdownType]="data.singleAnnouncement.showDaysOnly ? countdownTypes.DAYS : countdownTypes.FULL"
      [countdownLabel]="data.singleAnnouncement.countdownLabel || ''"
      [countdownDate]="data.singleAnnouncement.countdownDate || null"
      [fuelLabel]="data.fuelLabel"
      [media]="data.background"
      [routerLink]="data.links.length ? data.links[0].link : ''"
      [class.has-link]="!!data.links.length"
      [isRearCountdown]="true"
    ></mb-announcement-banner-small>
  }
</ng-template>
